function explicitHeight(content) {
  const contentHeight = content.scrollHeight;
  const transitionDuration = content.getAttribute('data-collapse-speed') ? parseInt(content.getAttribute('data-collapse-speed')) : 160;
  content.style.borderBottomWidth = null;
  content.style.borderTopWidth = null;
  content.style.height = `${contentHeight}px`;
  content.style.marginBottom = null;
  content.style.marginTop = null;
  content.style.paddingBottom = null;
  content.style.paddingTop = null;
  content.style.transitionDuration = `${transitionDuration}ms`;
  return transitionDuration;
}
export default {
  shouldBeHidden(content) {
    return !content.hasAttribute('data-closing') && content.offsetHeight;
  },
  show(content) {
    content.removeAttribute('data-closing');
    content.style.visibility = null;
    content.setAttribute('data-opening', setTimeout(() => {
      content.style.height = 'auto';
      content.style.overflow = null;
      content.removeAttribute('data-opening');
    }, explicitHeight(content)));
  },
  hide(content) {
    clearTimeout(parseInt(content.getAttribute('data-opening'), 10));
    content.removeAttribute('data-opening');
    content.setAttribute('data-closing', setTimeout(() => {
      content.removeAttribute('data-closing');
      content.style.visibility = 'hidden';
    }, explicitHeight(content)));
    content.style.overflow = 'hidden';
    window.getComputedStyle(content).getPropertyValue('height');
    content.style.borderBottomWidth = '0px';
    content.style.borderTopWidth = '0px';
    content.style.height = '0px';
    content.style.marginBottom = '0px';
    content.style.marginTop = '0px';
    content.style.paddingBottom = '0px';
    content.style.paddingTop = '0px';
  }
};